// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"TabA_TheComp__Gulsu","Win1":"TabA_Win1__jEI7Q","Win3":"TabA_Win3__g1yi_"};